import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import PortfolioCarouselMobile from './index_mobile';
import PortfolioCarouselWeb from './index_web';

const PortfolioCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  return isMobile ? <PortfolioCarouselMobile /> : <PortfolioCarouselWeb />;
};

export default PortfolioCarousel;
